import request from '../untils/request';

export const operationMessageListApi = params => {
  return request({
    url: '/operation/message/index',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};
